import * as React from 'react';
import { Paper, Grid, Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  EXT_TOS,
  EXT_PRIVACYPOLICY,
  EXT_WHATISLINKTIVITY,
  EXT_FAQS,
  EXT_TUTORIALS,
  EXT_CONTACT,
} from '../../routes/CONSTANTS';

const Item = styled(Paper)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  paddingRight: theme.spacing(0),
  paddingLeft: theme.spacing(0),
  backgroundColor: theme.palette.tertiary.extraLight,
}));
const ItemBottom = styled(Paper)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(1),
  paddingRight: theme.spacing(0),
  paddingLeft: theme.spacing(0),
  backgroundColor: '#fff',
}));

export default function Footer() {
  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='stretch'
      sx={{ marginTop: '2vh' }}
    >
      <Grid
        item
        md={1.5}
        xs={0}
        sx={{ backgroundColor: 'tertiary.extraLight' }}
      ></Grid>
      <Grid item md={3} xs={4} sx={{ backgroundColor: 'tertiary.extraLight' }}>
        <Item elevation={0} square>
          <Typography variant='body2'>LINKtivity® Learning</Typography>
          <Typography variant='body2'>
            <Link href={EXT_TOS} target='_blank' rel='noreferrer'>
              Terms of Service
            </Link>
          </Typography>
          <Typography variant='body2'>
            <Link href={EXT_PRIVACYPOLICY} target='_blank' rel='noreferrer'>
              Privacy Policy
            </Link>
          </Typography>
        </Item>
      </Grid>
      <Grid item md={3} xs={4} sx={{ backgroundColor: 'tertiary.extraLight' }}>
        <Item elevation={0} square>
          <Typography variant='body2'>INFO</Typography>
          <Typography variant='body2'>
            <Link href={EXT_WHATISLINKTIVITY} target='_blank' rel='noreferrer'>
              About LINKtivities
            </Link>
          </Typography>
          <Typography variant='body2'>
            <Link href={EXT_FAQS} target='_blank' rel='noreferrer'>
              FAQs
            </Link>
          </Typography>
          <Typography variant='body2'>
            <Link href={EXT_TUTORIALS} target='_blank' rel='noreferrer'>
              Video Tutorials
            </Link>
          </Typography>
        </Item>
      </Grid>
      <Grid item md={3} xs={4} sx={{ backgroundColor: 'tertiary.extraLight' }}>
        <Item elevation={0} square>
          <Typography variant='body2'>CONTACT</Typography>
          <Typography variant='body2'>
            <Link href={EXT_CONTACT} target='_blank' rel='noreferrer'>
              Contact Us
            </Link>
          </Typography>
        </Item>
      </Grid>
      <Grid
        item
        md={1.5}
        xs={0}
        sx={{ backgroundColor: 'tertiary.extraLight' }}
      ></Grid>
      <Grid item xs={12}>
        <ItemBottom elevation={0} square>
          <Typography variant='body2'>
            © {new Date().getFullYear()} LINKtivity® Learning. ALL RIGHTS
            RESERVED
          </Typography>
        </ItemBottom>
      </Grid>
    </Grid>
  );
}
